import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import EventAvailableRoundedIcon from "@mui/icons-material/EventAvailableRounded";
import NightsStayRoundedIcon from "@mui/icons-material/NightsStayRounded";
import PublicRoundedIcon from "@mui/icons-material/PublicRounded";
import "./styles.scss";

type WorkingHoursItem = {
	day: string;
	start: string | null;
	end: string | null;
	active: boolean;
};

const workingHoursConfig = {
	timezone: "Asia/Muscat",
	timezoneLabel: "بتوقيت عُمان",
	items: [
		{ day: "الأحد", start: "8:00 صباحاً", end: "5:00 مساءً", active: true },
		{ day: "الإثنين", start: "8:00 صباحاً", end: "5:00 مساءً", active: true },
		{ day: "الثلاثاء", start: "8:00 صباحاً", end: "5:00 مساءً", active: true },
		{ day: "الأربعاء", start: "8:00 صباحاً", end: "5:00 مساءً", active: true },
		{ day: "الخميس", start: "8:00 صباحاً", end: "5:00 مساءً", active: true },
		{ day: "الجمعة", start: null, end: null, active: false },
		{ day: "السبت", start: null, end: null, active: false },
	] satisfies WorkingHoursItem[],
};

export default function WorkingHours() {
	const workingDays = workingHoursConfig.items.filter((item) => item.active);
	const closedDays = workingHoursConfig.items.filter((item) => !item.active);

	return (
		<div className="working-hours-card" dir="rtl">
			<div className="working-hours-header">
				<div className="working-hours-title">
					<span className="working-hours-icon">
						<AccessTimeRoundedIcon />
					</span>
					<div>
						<h3>جدول الأسبوع</h3>
						<p title={workingHoursConfig.timezone}>
							<PublicRoundedIcon />
							{workingHoursConfig.timezoneLabel}
						</p>
					</div>
				</div>
				<span className="working-hours-status">متاح</span>
			</div>

			<div className="working-hours-list">
				{workingDays.map((item) => (
					<div className="working-hours-row" key={item.day}>
						<span>
							<EventAvailableRoundedIcon />
							{item.day}
						</span>
						<strong>
							{item.start} - {item.end}
						</strong>
					</div>
				))}
			</div>

			<div className="working-hours-closed">
				<span>
					<NightsStayRoundedIcon />
					أيام الإجازة
				</span>
				<strong>{closedDays.map((item) => item.day).join(" - ")}</strong>
				<em>مغلق</em>
			</div>
		</div>
	);
}
